import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight, Plus } from "lucide-react";
import { fmtPrice } from "./Reveal";
import { useStore } from "../context/StoreContext";
import { useLang } from "../context/LanguageContext";

export default function ProductCard({ product, index = 0 }) {
  const { addToCart } = useStore();
  const { t } = useLang();
  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.7, delay: (index % 3) * 0.08, ease: [0.22, 1, 0.36, 1] }}
      className="group relative"
      data-testid={`product-card-${product.slug}`}
    >
      <Link to={`/producto/${product.slug}`} className="block">
        <div className="relative overflow-hidden bg-surface aspect-[4/5]">
          <img src={product.image} alt={product.name}
            className="w-full h-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-105" />
          <div className="absolute inset-0 bg-inverse/0 group-hover:bg-inverse/20 transition-colors duration-500" />
          <span className="absolute top-4 left-4 overline bg-[color:var(--bg)]/90 text-ink px-3 py-1.5">{t(`cat.${product.category}`)}</span>
          <span className={`absolute top-4 right-4 overline px-3 py-1.5 ${product.availability === "on_demand" ? "bg-ink/80 text-[color:var(--bg)]" : "bg-gold text-inverse"}`}>{t(`avail.${product.availability || "in_stock"}`)}</span>
          <div className="absolute bottom-4 right-4 w-11 h-11 bg-gold text-inverse flex items-center justify-center translate-y-3 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-[transform,opacity] duration-400">
            <ArrowUpRight className="w-5 h-5" />
          </div>
        </div>
      </Link>
      <div className="flex items-start justify-between gap-4 mt-4">
        <div className="min-w-0">
          <p className="font-mono text-xs text-gold mb-1">{product.brand || product.tagline}</p>
          <Link to={`/producto/${product.slug}`}><h3 className="font-display font-medium text-lg leading-tight truncate hover:text-gold transition-colors">{product.name}</h3></Link>
          <p className="text-ink/50 text-sm mt-1">{fmtPrice(product.price, product.currency)} {product.unit && <span className="text-ink/30">/ {product.unit}</span>}</p>
        </div>
        <button onClick={() => addToCart(product)} data-testid={`add-cart-${product.slug}`}
          className="shrink-0 w-10 h-10 border border-ink/15 flex items-center justify-center hover:bg-blue hover:text-[color:var(--bg)] hover:border-blue transition-colors duration-300">
          <Plus className="w-4 h-4" />
        </button>
      </div>
    </motion.div>
  );
}
